import script from "./DashboardNav.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardNav.vue?vue&type=script&setup=true&lang=js"

import "./DashboardNav.vue?vue&type=style&index=0&id=3a62032b&lang=css"

const __exports__ = script;

export default __exports__